import type { Alert, Anomaly, Invoice, WorkShift } from '@/shared/api/types'
import { daysSince } from './index'

/** Échelle commune aux alertes et aux anomalies côté API. */
const SEVERITY_TONE: Record<string, 'bad' | 'warn' | 'info'> = {
  low: 'info',
  medium: 'warn',
  high: 'bad',
  critical: 'bad',
}

export const isSerious = (severity: string): boolean =>
  severity === 'high' || severity === 'critical'

export const alertTone = (a: Alert): 'bad' | 'warn' | 'info' => SEVERITY_TONE[a.severity] ?? 'info'

export const anomalyTone = (a: Anomaly): 'bad' | 'warn' | 'info' =>
  SEVERITY_TONE[a.severity] ?? 'info'

export const shiftTone = (s: WorkShift): 'bad' | 'warn' | 'good' | 'info' =>
  s.status === 'discrepancy'
    ? 'bad'
    : s.status === 'pending_validation'
      ? 'warn'
      : s.status === 'validated'
        ? 'good'
        : 'info'

export const invoiceOverdue = (i: Invoice): boolean =>
  i.status === 'open' && daysSince(i.due_at) > 0

export const SEVERITY: Record<string, string> = {
  low: 'Faible',
  medium: 'Moyenne',
  high: 'Élevée',
  critical: 'Critique',
}
export const ANOMALY_STATUS: Record<string, { label: string; tone: 'bad' | 'warn' | 'good' }> = {
  new: { label: 'Nouvelle', tone: 'bad' },
  investigating: { label: 'En cours', tone: 'warn' },
  resolved: { label: 'Résolue', tone: 'good' },
}
